module.exports = __webpack_public_path__ + "static/img/4Act.31858dca.png";